function accessProperty(o, s) {
  s = s.replace(/\[(\w+)\]/g, ".$1"); // convert indexes to properties
  s = s.replace(/^\./, ""); // strip a leading dot
  var a = s.split(".");
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (k in o) {
      o = o[k];
    } else {
      return;
    }
  }
  return o;
}

function can(object: any, _keyPath: string, debug = "") {
  const keyPath = _keyPath.split(".");
  keyPath.shift();

  try {
    const stdout = accessProperty(object, keyPath.join("."));

    return stdout;
  } catch (e) {
    return "";
  }
}

export default can;
